import React from 'react'

interface Props{
    openBullet: boolean,
    currentBulletImage: string,
    currentBulletText: string,
    handleOpenBullet: any
}

interface State{}

class OpenBulletMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.openBullet ? 'open-bullet-mobile fade-in':'open-bullet-mobile fade-out'}>
                <div className='bullet-container-mobile'>
                    <div className='bullet-image-container-mobile'>
                        <img src={this.props.currentBulletImage} />
                    </div>
                    <div className='bullet-text-container-mobile'>
                        <div className='bullet-text-mobile'>
                            {this.props.currentBulletText}
                        </div>
                        <div className='close-bullet-btn-mobile' onClick={() => {this.props.handleOpenBullet()}}>OK</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OpenBulletMobile